/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompanySearchRequest { 
    searchField: CompanySearchRequest.SearchFieldEnum;
    searchValue: string;
}
export namespace CompanySearchRequest {
    export const SearchFieldEnum = {
        Efan: 'EFAN',
        Domain: 'DOMAIN',
        EpmCompanyId: 'EPM_COMPANY_ID'
    } as const;
    export type SearchFieldEnum = typeof SearchFieldEnum[keyof typeof SearchFieldEnum];
}


